import { Box, Grid, Paper } from "@mui/material";
import Breadcrumb from "../../App/Components/Navigation/Subcomponents/Breadcrumbs/Breadcrumbs";
import { PageContainer } from "../../App/Components/PageContainer/PageContainer";
import { PageTitle } from "../../App/Components/PageTitle/PageTitle";
import { MessageDeliveryType } from "../../App/Enums/Message";
import CandidateMessageContainer from "../Components/CandidateMessageContainer";
import ContactList from "../Components/ContactList";
import ContactListFilters from "../Components/ContactListFilters";
import { MessageCenterCandidateText } from "../Components/MessageCenterCandidateText";
import { FilterContextProvider } from "../State/FilterContext";
import { GroupsContextProvider } from "../State/GroupsContext";
import { MessagesContextProvider, useMessagesContext } from "../State/MessagesContext";

export default function TextMessages() {
  return (
    <PageContainer>
      <Grid container>
        <Grid item xs={12}>
          <Breadcrumb pageTitle="Text Messages" />
        </Grid>
      </Grid>
      <Paper sx={{ mt: { xs: 1, md: 2 }, p: { xs: 2, lg: 4 } }}>
        <GroupsContextProvider>
          <FilterContextProvider>
            <MessagesContextProvider>
              <Grid container>
                <Grid item xs={12} sx={{ marginBottom: "20px" }}>
                  <PageTitle sx={{ lineHeight: 1 }}>Text Messages</PageTitle>
                </Grid>
              </Grid>
              <Grid container columnSpacing={{ xs: 4, xl: 6 }} rowSpacing={3}>
                <Grid item xs={12}>
                  <ContactListFilters />
                </Grid>
                <Grid item xs={12} sm={12} md={4} xl={3}>
                  <ContactList type={MessageDeliveryType.Text} />
                </Grid>
                <Grid item xs={12} sm={12} md={8} xl={9}>
                  <MessagesContainerWithContext />
                </Grid>
              </Grid>
            </MessagesContextProvider>
          </FilterContextProvider>
        </GroupsContextProvider>
      </Paper>
    </PageContainer>
  );
}

const MessagesContainerWithContext = () => {
  const { selectedCandidate } = useMessagesContext();
  return (
    <CandidateMessageContainer key={selectedCandidate?.id}>
      <Box sx={{ maxHeight: 650, height: "100%" }}>
        <MessageCenterCandidateText candidate={selectedCandidate} />
      </Box>
    </CandidateMessageContainer>
  );
};
